import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["templateYesRadio"]

  handleCustomerChange = (event) => {
    if (event.target.checked) {
      this.templateYesRadioTarget.checked = false
    }
  }
}
